import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { EShowModalSource } from '@src/slide/application/service/theme-color-manager/index.interface';

@Feature()
export class ChangeThemeFeature extends BaseToolbarFeature {
    public id = config.id;
    public config = config;

    public onClick(props?: { showCustomTab?: boolean, reportConfig?: any }) {
        const { showCustomTab, reportConfig } = props || {};
        this.getAppService().editableServiceLayer?.themeColorManager?.showThemeModal({
            source: EShowModalSource.toolbar,
            showCustomTab,
        });
        this.twdReport(undefined, undefined, reportConfig);
    }
}
